import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { updateData } from '../../../services';
import ConfirmDialog from '../../helpers/ConfirmDialog';
import { isProjectArchived } from '../../../utils/projects';

export const UnarchiveProjectForm = ({ project }) => {
    const { token, base_url, setProjects, user } = useAppContext();

    if (!user?.is_super_admin || !isProjectArchived(project)) {
        return null;
    }

    return (
        <ConfirmDialog
            trigger={
                <button
                    className="btn btn-secondary"
                    title="Unarchive Project"
                >
                    <FontAwesomeIcon icon={faUndo} />
                    &nbsp;
                    Unarchive Project
                </button>
            }
            title="Unarchive Project"
            message="Are you sure you want to unarchive this project?"
            entityLabel={`Project: ${project?.project_name}`}
            detail="This action will restore the project to your active projects list."
            confirmLabel="Unarchive Project"
            submittingLabel="Unarchiving..."
            successMessage="Project unarchived successfully!"
            errorMessages={{
                notFound: 'Project not found',
                client: 'Invalid project data. Please check your input.',
                default: 'Failed to unarchive project. Please try again.',
            }}
            onConfirm={async () => {
                const updated_project = await updateData(
                    token,
                    `${base_url}/apis/projects/${project.id}`,
                    { is_archived: false }
                );

                if (!updated_project.project) return false;

                setProjects((prevProjects) =>
                    prevProjects.map((p) =>
                        p.id === project.id ? updated_project.project : p
                    )
                );
            }}
        />
    );
};
